/* eslint-disable */ 
import { formatParams } from '@/utils/utils'
// 原生Ajax 
export const ajax = function () {
  function request(opt) {
    function fn() {}
    var url = opt.url || "";
    var async = opt.async !== false, method = opt.method || 'GET', data = opt.data ||
      null, success = opt.success || fn, error = opt.failure ||
      fn;
    method = method.toUpperCase();
    if (method == 'GET' && data) {
      var args = "";
      if (typeof data == 'string') {
        args = data;
      } else if (typeof data == 'object') {
        var arr = new Array();
        for (var k in data) {
          var v = data[k];
          arr.push(k + "=" + v);
        }
        args = arr.join("&");
      }
      url += (url.indexOf('?') == -1 ? '?' : '&') + args;
      data = null;
    }
    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() :
      new ActiveXObject('Microsoft.XMLHTTP');
    xhr.onreadystatechange = function () {
      _onStateChange(xhr, success, error);
    };
    xhr.open(method, url, async);
    if (method == 'POST') {
      xhr.setRequestHeader('Content-type',
        'application/x-www-form-urlencoded;');
    }
    xhr.send(data);
    return xhr;
  }

  function _onStateChange(xhr, success, failure) {
    if (xhr.readyState == 4) {
      var s = xhr.status;
      if (s >= 200 && s < 300) {
        success(xhr);
      } else {
        failure(xhr);
      }
    } else {}
  }
  return {
    request: request
  }
}()

// jsonp
export const jsonp = function (options) {
  options = options || {};
  if (!options.url || !options.callback) {
    throw new Error("参数不合法");
  }
  var callbackName = ('jsonp_' + Math.random()).replace(".", "");
  var oHead = document.getElementsByTagName('head')[0];
  options.data[options.callback] = callbackName;
  var params = formatParams(options.data);
  var oS = document.createElement('script');
  oHead.appendChild(oS);

  //创建jsonp回调函数
  window[callbackName] = function (json) {
    oHead.removeChild(oS);
    clearTimeout(oS.timer);
    window[callbackName] = null;
    options.success && options.success(json);
  };

  //发送请求
  oS.src = options.url + '?' + params;

  //超时处理
  if (options.time) {
    oS.timer = setTimeout(function () {
      window[callbackName] = null;
      oHead.removeChild(oS);
      options.fail && options.fail({
        message: "超时"
      });
    }, options.time);
  }
}


